// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"240":"e05cc6bc","616":"8ae57e98","795":"f40c1010"}[chunkId] + ".chunk.js";
};